export const Timescales: Record<string, number> = {
  Yearly: 3,
  Quarterly: 2,
  Monthly: 1,
  Weekly: 0,
};
